import { keyframes } from "styled-components";
import { fadeInDown } from "react-animations";

const fadeInDownAnimation = keyframes`${fadeInDown}`;

export { fadeInDownAnimation };
